import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../core/i18n'
import { postService, utilService } from '../../../core/services'
import * as constants from '../../../static/constants'
import * as interfaces from '../../../static/interfaces'
import * as Hooks from '../../../utils/hooks'
import injectGoogleMaps from '../../../utils/injectGoogleMaps'
import { Button, Pagination } from '../../atoms'
import SidebarLayout from '../_layouts/sidebarLayout'

interface IProps {
  google: any
  post: any
  reviews: any
  user: interfaces.IUser
}

declare var window: interfaces.IWindow

const DEFAULT_PAGE = 'show'
const SCORE_VALUES = [1, 2, 3, 4, 5]

export const PostShow: React.FC<IProps> = props => {
  const { post } = postService.getPostFromJson(props.post)
  Hooks.SetDocumentTitle(I18n.t('generic.reviews'))

  return <PostDetail {...props} post={post} user={props.user} />
}

interface IPostDetailProps extends IProps {
  post: any
  user: interfaces.IUser
}

export const PostDetail: React.FC<IPostDetailProps> = props => {
  const { data: reviews } = utilService.getDataFromJson(props.reviews.records)
  const { data: user } = utilService.getDataFromJson(props.user)
  const reviewsTotal = props.post.reviews_count
  const meta = props.reviews.records.meta

  const renderReplies = reply => {
    return (
      <div key={reply.id} className="Review_Reply">
        {reply.user && (
          <Avatar className="Avatar">
            <span className="Avatar_Image">
              <img src={reply.user.avatar_url} alt="" />
            </span>
            <div className="Avatar_Info">
              <h4>{reply.user.username}</h4>
              <span>{reply.user.joined_date}</span>
            </div>
          </Avatar>
        )}
        <p>{reply.body}</p>
      </div>
    )
  }

  const renderScore = (score, big = false) => {
    const Star = () => (
      <span className="Stars_Star">
        <svg
          viewBox="0 0 64 64"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="presentation"
        >
          <polygon
            fillRule="nonzero"
            points="32.5 45.9878947 48.877 56 44.531 37.13 59 24.4336842 39.9465 22.7963158 32.5 5 25.0535 22.7963158 6 24.4336842 20.469 37.13 16.123 56"
          />
        </svg>
      </span>
    )

    return (
      <Score className={`Score  ${big ? 'Big' : ''}`}>
        <div className="Score_StarsWrapper">
          <div className="Score_Stars">
            {SCORE_VALUES.map(value => (
              <Star key={value} />
            ))}
          </div>
          <div className="Score_Stars filled" style={{ width: `${(score / 5) * 100}%` }}>
            {SCORE_VALUES.map(value => (
              <Star key={value} />
            ))}
          </div>
        </div>
        <span className="Stars_Score">{score}</span>
      </Score>
    )
  }

  const renderPostImages = () => {
    if (!props.post.post_images.length) {
      return (
        <div className="PostShow_Image">
          <div className="PostShow_NoImage">No Image</div>
        </div>
      )
    }

    return (
      <div className="PostShow_Image">
        <img src={props.post.post_images[0].image_url} alt="" />
      </div>
    )
  }
  const rateBar = count => {
    return (
      <>
        <div className="Bar_Empty">
          <div className="Bar_Fill" style={{ width: `${(count / reviewsTotal) * 100}%` }} />
        </div>
        <p className="Rate_Count">{count}</p>
      </>
    )
  }
  // user.id === props.post.user.id <- use in showSidebar to show sidebar for guides/agent only
  return (
    <SidebarLayout user={user} showSidebar={false}>
      <PostShowWrapper className="PostShow">
        <div className="PostShow_Main">
          <div className="PostShow_Content">
            <div className="PostShow_Header">
              <div className="PostShow_HeaderAside">
                {renderPostImages()}
                <h2 className="PostShow_Title">{props.post.name}</h2>
                <Button>
                  <a href={`/posts/${props.post.slug}`}>{I18n.t('generic.show_detail')}</a>
                </Button>
              </div>
              <div className="PostShow_ReviewInfo">
                <div className="PostShow_ReviewCount">
                  <h3>{I18n.t('review.review_count', { count: reviewsTotal })}</h3>
                  <p className="review-caption">
                    All reviews are checked and confirmed before being posted.
                  </p>
                </div>
                <div className="PostShow_ReviewScore">
                  {renderScore(props.post.average_review_score, true)}
                  <div className="Rate_Filter">
                    <a href={`/posts/${props.post.slug}/reviews?rating=5`}>
                      <p className="Rate_Label">Excellent</p>
                      {rateBar(props.post.review_mapping['5'])}
                    </a>
                  </div>
                  <div className="Rate_Filter">
                    <a href={`/posts/${props.post.slug}/reviews?rating=4`}>
                      <p className="Rate_Label">Very Good</p>
                      {rateBar(props.post.review_mapping['4'])}
                    </a>
                  </div>
                  <div className="Rate_Filter">
                    <a href={`/posts/${props.post.slug}/reviews?rating=3`}>
                      <p className="Rate_Label">Average</p>
                      {rateBar(props.post.review_mapping['3'])}
                    </a>
                  </div>
                  <div className="Rate_Filter">
                    <a href={`/posts/${props.post.slug}/reviews?rating=2`}>
                      <p className="Rate_Label">Poor</p>
                      {rateBar(props.post.review_mapping['2'])}
                    </a>
                  </div>
                  <div className="Rate_Filter">
                    <a href={`/posts/${props.post.slug}/reviews?rating=1`}>
                      <p className="Rate_Label">Terrible</p>
                      {rateBar(props.post.review_mapping['1'])}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <section className="PostShow_Section">
              {reviews.map((review: interfaces.IReview, index) => (
                <Review key={index}>
                  <div className="Review_Main">
                    {review.reviewer ? (
                      <Avatar className="Avatar">
                        <a className="Avatar_Image" href={undefined} target="_blank">
                          <img src={review.reviewer.avatar_url} alt="" />
                        </a>
                        <div className="Avatar_Info">
                          <h4>{review.reviewer.username}</h4>
                          <span>{review.reviewer.joined_date}</span>
                        </div>
                      </Avatar>
                    ) : (
                      <Avatar className="Avatar">
                        <div className="Avatar_Image">
                          <img src={`${constants.ASSET_HOST}/images/no-avatar.svg`} alt="" />
                        </div>
                        <div className="Avatar_Info">
                          <h4>
                            {review.anonymous_review_author ||
                              review.direct_reservation?.guest_name ||
                              ''}
                          </h4>
                        </div>
                      </Avatar>
                    )}
                    <div className="Review_Score">
                      <p>{I18n.t('review.rating')}</p>
                      {renderScore(Math.round(review.rating / 2))}
                    </div>
                    <p className="Review_Body">{review.body}</p>
                  </div>
                  {review.review_reply ? renderReplies(review.review_reply) : null}
                </Review>
              ))}
            </section>
          </div>
        </div>
        <Pagination
          onChangePageHandler={page => {
            const searchParams = window.location.search
            if (searchParams.includes('rating=5')) {
              location.href = `${location.pathname}?rating=5&page=${page}`
            } else if (searchParams.includes('rating=4')) {
              location.href = `${location.pathname}?rating=4&page=${page}`
            } else if (searchParams.includes('rating=3')) {
              location.href = `${location.pathname}?rating=3&page=${page}`
            } else if (searchParams.includes('rating=2')) {
              location.href = `${location.pathname}?rating=2&page=${page}`
            } else if (searchParams.includes('rating=1')) {
              location.href = `${location.pathname}?rating=1&page=${page}`
            } else {
              location.href = `${location.pathname}?page=${page}`
            }
          }}
          currentPage={meta.current_page}
          prevPage={meta.prev_page}
          nextPage={meta.next_page}
          totalPages={meta.total_pages}
          totalCount={meta.total_count}
        />
      </PostShowWrapper>
    </SidebarLayout>
  )
}
const Avatar = styled.div`
  display: flex;
  align-items: center;

  .Avatar_Image {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    margin-right: 24px;
    overflow: hidden;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      width: 48px;
      height: 48px;
      margin-right: 12px;
    }

    > img {
      width: inherit;
      height: inherit;
      object-fit: cover;
    }
  }

  .Avatar_Info {
    flex: 1;

    h4 {
      font-size: 16px;
      margin-bottom: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    > span {
      display: block;
    }
  }
`

const Review = styled.div`
  padding-bottom: 32px;

  & + & {
    padding-top: 32px;
    border-top: solid 1px ${constants.COLORS.divider};
  }

  .Review_Score {
    margin-top: 20px;
  }

  .Review_Body {
    margin-top: 8px;
    white-space: pre-wrap;
  }

  .Review_Reply {
    margin-top: 24px;
    margin-left: 48px;
  }
`

const AddReply = styled.div`
  margin-top: 24px;

  .Form {
    margin-top: 12px;
  }

  textarea {
    display: block;
    width: 100%;
    height: 160px;
    padding: 8px 12px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 4px;
    font-size: 15px;
    transition: border 0.2s ease;
    outline: none;
    background: none;

    &:focus {
      border: solid 1px ${constants.COLORS.primary};
    }
  }

  .AddReply_Editor {
    margin-left: 48px;
  }

  .AddReply_Footer {
    margin-top: 12px;
  }
`

const Score = styled.div`
  display: flex;
  align-items: center;
  &.Big {
    .Score_StarsWrapper {
      width: 120px;
      height: 24px;
      .Stars_Star {
        width: 24px;
        height: 24px;
      }

      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        width: 90px;
        height: 18px;
        .Stars_Star {
          width: 18px;
          height: 18px;
        }
        .Stars_Score {
          font-size: 12px;
        }
      }
    }
  }
  .Stars_Score {
    margin-left: 6px;
    font-weight: bold;
    font-size: 14px;
    line-height: 1;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      font-size: 12px;
    }
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 10px;
    }
  }

  .Score_StarsWrapper {
    position: relative;
    width: 90px;
    height: 18px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      width: 80px;
      height: 16px;
    }
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      width: 60px;
      height: 12px;
    }
  }

  .Score_Stars {
    position: absolute;
    top: 0;
    left: 0;
    align-items: center;
    display: flex;

    svg {
      position: absolute;
      top: 0;
      left: 0;
    }

    &.filled {
      overflow: hidden;

      svg {
        fill: ${constants.COLORS.useally};
      }
    }
  }

  .Stars_Star {
    position: relative;
    display: block;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      width: 16px;
      height: 16px;
    }
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      width: 12px;
      height: 12px;
    }

    svg {
      width: inherit;
      height: inherit;
      fill: ${constants.COLORS.subText};
    }
  }
`

const PostShowWrapper = styled.div`
  .PostShow_Main {
    display: flex;
    max-width: 1088px;
    margin: 32px auto 0;
    padding: 0 24px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      padding: 0 24px 96px;
    }
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      padding: 0 12px 96px;
    }
  }

  .PostShow_Image {
    width: 100%;
    height: 380px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      height: 280px;
    }
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      height: 140px;
    }

    > img {
      width: 100%;
      height: inherit;
      object-fit: cover;
    }
  }

  .PostShow_NoImage {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${constants.COLORS.white};
  }

  .PostShow_Content {
    display: flex;
    flex-direction: column;
    flex: 1;
    line-height: 1.5;
    margin-top: 16px;
    width: 100%;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      flex: initial;
    }
  }

  .PostShow_Header {
    padding-bottom: 16px;
  }

  .PostShow_HeaderAside .PostShow_Title {
    margin: 8px 0;
  }

  .PostShow_ReviewInfo {
    flex: 0;
    margin-top: 8px;
  }

  .PostShow_ReviewCount {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    h3 {
      margin: 0 8px 8px 0;
    }
    .review-caption {
      position: relative;
      line-height: 16px;
      margin-bottom: 8px;
      font-size: 13px;
      padding-left: 13px;
      &::before {
        content: '*';
        position: absolute;
        left: 0;
      }
    }
  }

  .PostShow_ReviewScore .Score {
    margin-bottom: 8px;
  }

  .PostShow_Avatar {
    display: flex;
    align-items: center;

    .PostShow_AvatarImage {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      margin-right: 24px;
      overflow: hidden;
      @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
        margin-right: 12px;
      }

      > img {
        width: inherit;
        height: inherit;
        object-fit: cover;
      }
    }

    .PostShow_AvatarInfo {
      flex: 1;

      h4 {
        font-size: 20px;
        margin-bottom: 4px;
        @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
          font-size: 14px;
        }
      }

      > span {
        display: block;
        font-size: 14px;
        @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
          font-size: 12px;
        }
      }
    }
  }

  .PostShow_Title {
    font-weight: bold;
    font-size: 32px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      font-size: 24px;
    }
  }

  .PostShow_Section {
    flex: 0;
    width: 100%;
    border-top: solid 1px ${constants.COLORS.divider};
    padding: 32px 0 48px;

    > h3 {
      font-size: 20px;
    }
  }

  .Rate_Filter {
    min-width: 260px;
    margin: 4px 0;
    color: ${constants.COLORS.black};

    &:hover {
      color: ${constants.COLORS.primary};
      .Bar_Empty {
        border: ${constants.COLORS.primary} 1px solid;
      }
    }

    a {
      display: flex;
      color: inherit;
    }

    .Rate_Label {
      width: 82px;
      margin-right: 12px;
    }
    .Rate_Count {
      margin-left: 12px;
      min-width: 32px;
    }

    .Bar_Empty {
      border-radius: 4px;
      border: ${constants.COLORS.divider} 1px solid;
      width: 120px;
      .Bar_Fill {
        border-radius: 4px;
        height: 100%;
        background-color: ${constants.COLORS.useally};
      }
    }
  }
`

export default injectGoogleMaps(PostShow)
